import { call, put, takeLatest, select } from 'redux-saga/effects';
import api from '@control-front-end/common/sagas/api';
import {
  GET_FORMS,
  GET_SYSTEM_FORMS,
  SET_FORMS_REQ_STATUS,
  SEARCH_FORMS,
  REMOVE_FORM,
} from '../constants/forms';
import { makeFormModel } from './formView';
import { RequestStatus } from '../constants/index';

/**
 * Получить список
 */
function* getForms({ payload, callback }) {
  const accounts = yield select((state) => state.accounts);
  const accId = payload.accId || accounts.active;
  const {
    loadMore,
    localState,
    withDefault,
    withTotal,
    formTypes,
    limit: customLimit,
  } = payload;
  let formState;
  if (localState) {
    formState = localState;
  } else {
    formState = yield select((state) => state.formList);
  }
  const {
    endList,
    reqStatus,
    list,
    limit: defaultLimit,
    offset,
    loadCount,
  } = formState;
  if (reqStatus !== RequestStatus.SUCCESS || endList) return;
  // Ставим флаг прогресса загрузки
  yield put({ type: SET_FORMS_REQ_STATUS, payload: 'inProgress' });
  const reqTime = new Date().getTime();
  const url = `/forms/templates/${accId}`;
  const limit = customLimit || defaultLimit;
  const { result, data } = yield call(api, {
    method: 'get',
    url,
    queryParams: {
      limit,
      offset,
      withDefault,
      withTotal,
      formTypes,
    },
  });
  // Отсекаем ответ на пред. запрос
  const { reqTime: lastReqTime } = yield select((state) => state.formList);
  if (!localState && reqTime < lastReqTime) return;
  // Ставим флаг окончания загрузки
  yield put({ type: SET_FORMS_REQ_STATUS, payload: 'success' });
  if (result !== RequestStatus.SUCCESS) return;
  const newList = withTotal ? data.data.list : data.data;
  yield call(makeFormModel, newList);
  const newFormsList = loadMore ? list.concat(newList) : newList;
  const newPayload = {
    list: newFormsList,
    limit,
    offset: offset + limit,
    loadCount: loadCount + 1,
    endList: !newList.length,
    total: data.data.total || newFormsList.length,
    reqTime,
  };
  if (localState && callback) {
    callback({ ...localState, ...newPayload });
    return;
  }
  yield put({
    type: GET_FORMS.SUCCESS,
    payload: newPayload,
  });
  if (callback) callback();
}

/**
 * Получить системные формы
 */
function* getSystemForms({ payload }) {
  const { accId, formTypes } = payload;
  const { result, data } = yield call(api, {
    method: 'get',
    url: `/forms/templates/system/${accId}`,
    queryParams: {
      formTypes,
    },
  });
  if (result !== RequestStatus.SUCCESS) return;
  const mapForms = {};
  for (const i of data.data) {
    mapForms[i.title.toLowerCase()] = i;
  }
  yield put({
    type: GET_SYSTEM_FORMS.SUCCESS,
    payload: mapForms,
  });
}

/**
 * Поиск
 */
function* searchForms({ payload, callback }) {
  const accounts = yield select((state) => state.accounts);
  const accId = payload.accId || accounts.active;
  const { query } = payload;
  const { result, data } = yield call(api, {
    method: 'get',
    url: `/forms/search/${accId}/${encodeURIComponent(query)}`,
  });
  if (result !== RequestStatus.SUCCESS) return;
  yield call(makeFormModel, data.data);
  if (callback) {
    callback({ list: data.data });
    return;
  }
  yield put({
    type: SEARCH_FORMS.SUCCESS,
    payload: {
      list: data.data,
      offset: 0,
      loadCount: 0,
      endList: false,
    },
  });
}

/**
 * Удалить шаблон формы
 */
function* removeForm({ payload }) {
  const { formId } = payload;
  const { result } = yield call(api, {
    method: 'delete',
    url: `/forms/${formId}`,
  });
  if (result !== RequestStatus.SUCCESS) return;
  const { list } = yield select((state) => state.formList);
  const index = list.findIndex((i) => i.id === formId);
  if (index === -1) return;
  const copyList = list.slice();
  copyList.splice(index, 1);
  yield put({
    type: REMOVE_FORM.SUCCESS,
    payload: { list: copyList },
  });
}

function* formList() {
  yield takeLatest(GET_FORMS.REQUEST, getForms);
  yield takeLatest(GET_SYSTEM_FORMS.REQUEST, getSystemForms);
  yield takeLatest(SEARCH_FORMS.REQUEST, searchForms);
  yield takeLatest(REMOVE_FORM.REQUEST, removeForm);
}

export default formList;
